import ChevronLeft from '@mui/icons-material/ChevronLeft'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { LoadingButton } from '@mui/lab'
import { Box, Button, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

type Props = {
  canContinue: boolean
  canGoPrevious: boolean
  isUpdating: boolean
  onClickContinue(): void
  onClickExit(): void
  onClickPrevious(): void
}

export const NavButtons = ({
  canContinue,
  canGoPrevious,
  onClickContinue,
  onClickExit,
  isUpdating,
  onClickPrevious,
}: Props) => {
  const { t } = useTranslation('@cibo/landmanager/TraitTable')

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2}>
      <Button onClick={onClickPrevious} disabled={!canGoPrevious} startIcon={<ChevronLeft />}>
        {t('previous')}
      </Button>
      <Box sx={{ flex: 1 }} />
      <LoadingButton
        fullWidth={false}
        onClick={onClickExit}
        variant="outlined"
        disabled={isUpdating}
      >
        {t('finishLater')}
      </LoadingButton>
      <LoadingButton
        fullWidth={false}
        onClick={onClickContinue}
        loading={isUpdating}
        disabled={!canContinue}
        data-testid="trait-table-continue"
        endIcon={<ChevronRight />}
      >
        {t('continue')}
      </LoadingButton>
    </Stack>
  )
}
